<div class="m-content">
  <div class="row">
    <div class="col-sm-12">
      <div class="m-portlet m-portlet--full-height">
        <div class="m-portlet__body">
          <div class="hx-filters">
            <div class="filter">
              <small>{{ 'realized-product.shop' | transloco }}</small>
              <hx-store-select [(ngModel)]="params.storeId" (selectChange)="navigate()"></hx-store-select>
            </div>

            <div class="filter">
              <small>{{ 'realized-product.data' | transloco }}</small>
              <hx-date-range-select [(ngModel)]="params.date" (selectChange)="navigate()"></hx-date-range-select>
            </div>
          </div>

          <button type="button" [disabled]="isLoading.generate" (click)="generate()" class="btn btn-outline-primary m--margin-top-15">
            {{ 'export1C' | transloco }}
          </button>

          <hr>

          <div class="m_datatable m-datatable--fixed-col m-datatable m-datatable--default m-datatable--loaded m--margin-top-30 m--margin-bottom-30 is--fixed-column">
            <table *ngIf="list.length && !isLoading.list" class="m-datatable__table m-datatable__table--width">
              <thead class="m-datatable__head">
              <tr class="m-datatable__row m-datatable__row--head">
                <th class="m-datatable__cell m-datatable__cell--fixed-col" style="height: 40%;">
                  <span>{{ 'realized-product.data' | transloco }}</span>
                </th>
                <th class="m-datatable__cell">
                  <span>{{ 'realized-product.shop' | transloco }}</span>
                </th>
                <th class="m-datatable__cell">
                  <span>{{ 'realized-product.table.head.shopCode' | transloco }}</span>
                </th>
                <th class="m-datatable__cell text-center">
                  <span>{{ 'realized-product.table.head.product' | transloco }}</span>
                </th>
                <th class="m-datatable__cell text-center">
                  <span>{{ 'realized-product.table.head.shopProduct' | transloco }}</span>
                </th>
                <th class="m-datatable__cell text-nowrap">
                  <span>{{ 'realized-product.table.head.quantity' | transloco }}</span>
                </th>
                <th class="m-datatable__cell m-datatable__cell--center">
                  <span>{{ 'realized-product.table.head.total' | transloco }}</span>
                </th>
              </tr>
              </thead>
              <tbody class="m-datatable__body">
              <ng-container *ngFor="let even = even;let i = index; let productItem of list">
                <tr class="m-datatable__row"
                    [ngClass]="{ 'm-datatable__row--even': even }">
                  <td class="m-datatable__cell m-datatable__cell--fixed-col">
                    {{ productItem.date }}
                  </td>
                  <td class="m-datatable__cell text-center">
                    {{ productItem.storeTitle | uiLabel }}
                  </td>
                  <td class="m-datatable__cell text-center">
                    {{ productItem.storeExt1cCode }}
                  </td>
                  <td class="m-datatable__cell text-center">
                    {{ productItem.productTitle | uiLabel }}
                  </td>
                  <td class="m-datatable__cell text-center">
                    {{ productItem.productExt1cCode }}
                  </td>
                  <td class="m-datatable__cell text-center">
                    {{ productItem.amount }}
                  </td>
                  <td class="m-datatable__cell text-center">
                    {{ productItem.total }}
                  </td>
                </tr>
              </ng-container>
              </tbody>
            </table>

            <hx-loader [length]="list.length" [isLoading]="isLoading.list"></hx-loader>
          </div>
          <div class="m--align-center" *ngIf="list.length && !isLoading.list && pagination.allItemCount > 0">
            <ngb-pagination [maxSize]="5" [rotate]="true" [collectionSize]="pagination.allItemCount"
                            [(page)]="params.page" [pageSize]="params.limit" (pageChange)="pageChanged($event)" class="d-flex justify-content-center mt-4">
            </ngb-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
